//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      upsells: {},
      isFixed: false,
      originalOffset: 0,
      scrollRAF: null
    }
  },
  computed: {
    ...mapState([ 'defaultMenu', 'menu', 'selectedCategory', 'options', 'location', 'order', 'errors' ]),
    displayMenu() {
      return this.menu ? this.menu : this.defaultMenu
    },
    category() {
      return this.selectedCategory
    },
    headerHeight() {
      const isMobile = this.$mq === 'sm'
      return isMobile ? 114 : 128
    }
  },
  async mounted() {
    await this.$nextTick()
    setTimeout(this.calculateDimensions, 300)

    if (!this.location) {
      await this.$api.getDefaultMenu()
    } else {
      await this.$api.getMenu()

      console.log('test location: ', this.location, this.order)

      if (this.order && this.order.menu_id != this.location.menu_id) {
        await this.$api.transferOrder()
      } else if (!this.order) {
        await this.$api.createOrder()
      }
    }

    if (!this.selectedCategory) {
      const category = this.displayMenu?.categories[0]
      this.$store.commit('setSelectedCategory', category)
    }

    this.initializeScrollListener()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
    if (this.scrollRAF) {
      cancelAnimationFrame(this.scrollRAF)
    }
  },
  methods: {
    ...mapMutations(['setDefaultMenu']),
    calculateDimensions() {
      if (this.$refs.placeholder) {
        // When the top of the viewport reaches the placeholder, the sticky container should be fixed
        const rect = this.$refs.placeholder.getBoundingClientRect()
        this.originalOffset = rect.top + window.pageYOffset
      }
    },
    initializeScrollListener() {
      const handleScroll = () => {
        this.scrollRAF = requestAnimationFrame(() => {
          const scrollPosition = window.pageYOffset
          this.isFixed = scrollPosition > (this.originalOffset - this.headerHeight)
        })
      }
      window.addEventListener('scroll', handleScroll, { passive: true })
    },
    handleResize() {
      if (this.scrollRAF) {
        cancelAnimationFrame(this.scrollRAF)
      }
      this.calculateDimensions()
    },
    viewProduct(item, cid) {
      let link = {}
      if (this.menu) {
        link = '/order/product?id='+item.sku+'&cat='+cid
      } else {
        link = '/menu/product/'+item.sku
      }
      this.$router.push(link)
    },
    async quickAdd(item) {
      await this.$store.dispatch('product/clearProduct')
      await this.$store.dispatch('product/getProduct', {
        id: item.sku,
        defaults: [],
        quantities: []
      })
      let update = await this.$store.dispatch('product/addToCart', {
        id: item.id,
      })
      if(this.errors.length == 0) {
        this.$store.commit('setShowCart', true)
        this.$store.dispatch('product/clearProduct')
      }
    },
    setCategory(category) {
      this.category = category
    },
    state(abbr) {
      let states = [
        ['Arizona', 'AZ'],
        ['Alabama', 'AL'],
        ['Alaska', 'AK'],
        ['Arkansas', 'AR'],
        ['California', 'CA'],
        ['Colorado', 'CO'],
        ['Connecticut', 'CT'],
        ['Delaware', 'DE'],
        ['Florida', 'FL'],
        ['Georgia', 'GA'],
        ['Hawaii', 'HI'],
        ['Idaho', 'ID'],
        ['Illinois', 'IL'],
        ['Indiana', 'IN'],
        ['Iowa', 'IA'],
        ['Kansas', 'KS'],
        ['Kentucky', 'KY'],
        ['Louisiana', 'LA'],
        ['Maine', 'ME'],
        ['Maryland', 'MD'],
        ['Massachusetts', 'MA'],
        ['Michigan', 'MI'],
        ['Minnesota', 'MN'],
        ['Mississippi', 'MS'],
        ['Missouri', 'MO'],
        ['Montana', 'MT'],
        ['Nebraska', 'NE'],
        ['Nevada', 'NV'],
        ['New Hampshire', 'NH'],
        ['New Jersey', 'NJ'],
        ['New Mexico', 'NM'],
        ['New York', 'NY'],
        ['North Carolina', 'NC'],
        ['North Dakota', 'ND'],
        ['Ohio', 'OH'],
        ['Oklahoma', 'OK'],
        ['Oregon', 'OR'],
        ['Pennsylvania', 'PA'],
        ['Rhode Island', 'RI'],
        ['South Carolina', 'SC'],
        ['South Dakota', 'SD'],
        ['Tennessee', 'TN'],
        ['Texas', 'TX'],
        ['Utah', 'UT'],
        ['Vermont', 'VT'],
        ['Virginia', 'VA'],
        ['Washington', 'WA'],
        ['West Virginia', 'WV'],
        ['Wisconsin', 'WI'],
        ['Wyoming', 'WY'],
      ]
      for (var i = 0; i < states.length; i++) {
        if (states[i][1] == abbr) {
          return states[i][0]
        }
      }
    }
  },
  watch: {
    category: {
      handler: function(val) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: "view_item_list",
          ecommerce: {
            location_code: this.location ? this.location.id : 'default',
            location_name: this.location ? this.location.name : 'default',
            item_list_id: this.category?.id,
            item_list_name: this.category?.name,
            items: this.category?.products.map(product => {
              return {
                item_id: product.id,
                item_name: product.name,
              }
            }),
          }
        })
      },
      deep: true,
      // immediate: true
    }
  }
}
